import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import SettingsPage from "../components/SettingsPage";
import useTitle from "../components/Title";

const Settings = () => {

  useTitle("- Settings ");
  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">

            <h1 className="mt-5 event-heading-start">Settings.</h1>
          <p className="event-sub-text mb-3"> This is where user settings will be managed.  </p>
          <div className="row justify-content-between filter-section mx-0 align-items-end">
          </div>

          <SettingsPage />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Settings;
